export const filterInfluencersByCheckStatus = async (supabase, checkStatusFilter) => {
  const CHECK_STATUS_FILTERS = {
    FREE_ONLY: "free_only",
    PAID_ONLY: "paid_only",
    BOTH: "both",
    NONE: "none",
  };

  const TABLES = {
    FREE_CHECKS: "influencer_free_checks",
    PAID_CHECKS: "influencer_paid_checks",
    INFLUENCERS: "influencers",
  };

  const getFreeCheckedIds = async (supabase) => {
    const result = await supabase
      .from(TABLES.FREE_CHECKS)
      .select("influencer_id")
      .eq("is_free_checked", true)
      .not("influencer_id", "is", null);
    if (result.error) {
      throw new Error(`Error fetching free checks: ${result.error.message}`);
    }
    return result.data?.map((item) => item.influencer_id) || [];
  };

  const getPaidCheckedIds = async (supabase) => {
    const result = await supabase
      .from(TABLES.PAID_CHECKS)
      .select("influencer_id")
      .eq("is_paid_checked", true)
      .not("influencer_id", "is", null);
    if (result.error) {
      throw new Error(`Error fetching paid checks: ${result.error.message}`);
    }
    return result.data?.map((item) => item.influencer_id) || [];
  };

  const getAllInfluencerIds = async (supabase) => {
    const result = await supabase.from(TABLES.INFLUENCERS).select("id").not("id", "is", null);
    if (result.error) {
      throw new Error(`Error fetching all influencers: ${result.error.message}`);
    }
    return result.data?.map((item) => item.id) || [];
  };

  const getAnyCheckedIds = async (supabase) => {
    const [freeIds, paidIds] = await Promise.all([getFreeCheckedIds(supabase), getPaidCheckedIds(supabase)]);
    return [...new Set([...freeIds, ...paidIds])];
  };

  try {
    switch (checkStatusFilter) {
      case CHECK_STATUS_FILTERS.FREE_ONLY: {
        const [freeIds, paidIds] = await Promise.all([getFreeCheckedIds(supabase), getPaidCheckedIds(supabase)]);
        return freeIds.filter((id) => !paidIds.includes(id));
      }
      case CHECK_STATUS_FILTERS.PAID_ONLY: {
        return await getPaidCheckedIds(supabase);
      }
      case CHECK_STATUS_FILTERS.BOTH: {
        const [freeIds, paidIds] = await Promise.all([getFreeCheckedIds(supabase), getPaidCheckedIds(supabase)]);
        return freeIds.filter((id) => paidIds.includes(id));
      }
      case CHECK_STATUS_FILTERS.NONE: {
        const [allIds, checkedIds] = await Promise.all([getAllInfluencerIds(supabase), getAnyCheckedIds(supabase)]);
        return allIds.filter((id) => !checkedIds.includes(id));
      }
      default:
        console.warn(`Unknown check status filter: ${checkStatusFilter}`);
        return [];
    }
  } catch (error) {
    console.error("Error in check status filter:", error);
    return [];
  }
};
